module.exports = __webpack_public_path__ + "img/Mikkel.1805de74.jpg";